import { render, staticRenderFns } from "./AdvanceAmount.vue?vue&type=template&id=061330fc&scoped=true&"
import script from "./AdvanceAmount.vue?vue&type=script&lang=js&"
export * from "./AdvanceAmount.vue?vue&type=script&lang=js&"
import style0 from "./AdvanceAmount.vue?vue&type=style&index=0&id=061330fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061330fc",
  null
  
)

export default component.exports